var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[(_vm.processo)?_c('Formulario',{attrs:{"processo":_vm.processo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }